<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <div  class="justify-content-center mt-3">
    <b-row>

      <b-col class="text-center justify-content-center" style="display: flex;">
        <div  style="width: 80%">
          <b-row>
            <b-col>
              <div class="mt-2" style="display: inline-flex; margin-top: 4px;">
                <span style="font-size: 12px;">Total de inversión: </span>
                <span style="font-size: 12px; font-weight: 500; color: #0069A9 "> {{ totalInversion | monedaEntero }} </span>
              </div>
            </b-col>
            <b-col>
              <div style="display: inline-flex;">
                <span style="font-size: 12px; margin-top: 12px; margin-right: 8px;">Total a pagar: </span>
                <b-form-input
                    v-model="montoPagar"
                    style="width: 46%"
                    type="number"
                    placeholder="$0"
                    min="1"
                    @keydown="filterJustNumber($event)"
                    @keyup.enter="calcularMontosFinanciamiento()"
                />
              </div>
            </b-col>
          </b-row>
        </div>

      </b-col>
    </b-row>

    <div class="d-flex justify-content-center text-center mt-2 mb-2">
      <img style="position: absolute" src="../../../assets/version5/dentaliaPay.png" alt="Dentalia Pay"/>
    </div>

    <div class="justify-content-center mt-4" style="display: flex;">
      <div style="width: 80%">
        <div class=" text-center m-2 " style="border-radius: 10px;">
          <b-table
              responsive
              id="tablaFinanciamiento"
              thead-tr-class="columnasTablaSinColor"
              :items="costoFinanciamiento"
              :fields="fields"
              selectable
              class="parrafos"
              fixed
              hover>
            <template #cell(plazo)="row">
              <span >{{row.item.plazo }} Quincenas</span>
            </template>
            <template #cell(pagoQuincenal)="row">
              <span >{{row.item.pagoQuincenal | monedaEntero}}</span>
            </template>

          </b-table>

          <span style="font-size: 10px; font-weight: 500; color: #EB6228" v-if="opcionesQuincenas.length === 0"
          > No se encontraron configuraciones de financiamiento</span>

          <span style="font-size: 10px; font-weight: 500; color: #0069A9" v-else-if="costoFinanciamiento.length === 0"
          > Por favor ingrese el "total a pagar" seguido de un enter (↵) </span>

        </div>
        <div class="justify-content-center text-center m-2 ">
          <br/>
          <span style="font-size: 10px; font-weight: 500; color: #EB6228"
          > Los precios están sujetos a revisión y aprobación </span>
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<style scoped>

</style>
<script>
export default {
  name: "TarjetaDeCreditoPF",
  props: {
    totalInversion: Number,
    idPaciente: Number
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    montoPagar: 0,
    costoFinanciamiento: [],
    opcionesQuincenas: [],
    fields: [
      {key: "plazo", label: "Plazo"},
      {key: "pagoQuincenal", label: "Pago Quincenal"},
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerQuincenasFinaciamientoAtrato();
  },
  methods: {
    calcularMontosFinanciamiento() {

      if (this.montoPagar > this.totalInversion){
        this.$bvToast.toast('Su total de inversion es ' + new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(
            this.totalInversion  ), {
          title: '¡El monto es mayor!' ,
          variant: 'danger',
          solid: false
        })
        return;
      }


      this.costoFinanciamiento = [];
      this.opcionesQuincenas.forEach(op => {
        let calculo = [];
        let tasaBruta = ((op.tasaNetaAnualidad/100)/24)*(1+(op.impuesto/100));

        let quincenaInversion = tasaBruta * this.montoPagar;
        let tasaElevada = 1-(Math.pow((1+tasaBruta),-(op.plazoQuincena)));
        let quincenas = quincenaInversion / tasaElevada;
        if (this.montoPagar >= op.montoMinimo){
          calculo.pagoQuincenal = Math.ceil(quincenas);
          calculo.plazo = op.plazoQuincena;
          this.costoFinanciamiento.push(calculo);
        }


      })

    },
    obtenerQuincenasFinaciamientoAtrato() {
      this.$http.post(this.$api + "atrato/obtenerActivos", this.totalInversion).then(respuesta => {
        if (respuesta.data.data) {
          this.opcionesQuincenas = respuesta.data.data;
        }
      }).catch(error => {
        console.error(error)
      })
    },
    filterJustNumber(e){
      const key = e.key;

      if (key === '-'){
        return e.preventDefault();
      }

      if (key === '+'){
        return e.preventDefault();
      }

      if (key === '.'){
        return e.preventDefault();
      }

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e'){
        return e.preventDefault();
      }

    },
  }
}
</script>